module.exports = __webpack_public_path__ + "img/guizhouHints_6.2aafb1b8.jpg";